import { Fragment, useContext, useState, useEffect, useLayoutEffect } from 'react';
import { Container, Row, Col, Table } from 'reactstrap';
import Breadcrumbs from "../../../CommonElements/Breadcrumbs"
import CustomizerContext from '../../../_helper/Customizer'; 
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { CaseApi, CaseGroupApi, CaseTypeApi, CustomerApi, CustomerLinkApi, PriorityApi, ResolutionStatusApi, } from "../../../api"
import { toast } from 'react-toastify';
import CardRibbonWithForm from '../../Common/Component/CardRibbonWithForm'; 
import { case_form_fields } from './Case';
import useAxiosPrivate from '../../../Hooks/useAxiosPrivate'; 
import { createDropdownField } from '../../../Data/FormField/PublicData';
import { CaseGroup, CaseTypeName, Contact, DelegateTeam, DelegationTime, EscalationExecutiveTime, EscalationFunctionalTime, ExternalDelegateTeam, GlobalResolutionTime, Link, PickUpTime, Priority, ResolutionStatus, ResolutionTeam, ResolutionTime, Timeline } from "../../../Constant"
import useAuth from '../../../Hooks/useAuth';
import CommonPopover from '../../Common/Component/CommonPopover';
import { formatToDuration } from '../../../_helper/utils';
import { selectCurrentUser } from '../../../redux/features/auth/authSlice';
import { useAppSelector } from '../../../redux/hooks/hook';

const MyCaseCreate = () => {
  const history = useNavigate();
  const { layoutURL } = useContext(CustomizerContext);
  const axiosPrivate = useAxiosPrivate()
  const { userOrganisationId } = useAuth();
  const currentUser = useAppSelector(selectCurrentUser)
  const lists = `${process.env.PUBLIC_URL}/selfcare/tickets/my-tickets/${layoutURL}`;

  const { formState: { errors },} = useForm(); 

  const [formFields, setFormFields] = useState(case_form_fields);
  const [isNewFieldAdded, setIsNewFieldAdded] = useState(false);
  const [caseTypeData, setCaseTypeData] = useState({});
  const [selectedCaseTypeId, setSelectedCaseTypeId] = useState(null);
  const [updatedFields, setUpdatedFields] = useState([]);

  const caseGroupDropdownField = createDropdownField(axiosPrivate,
    'case_group_id',
    'case_group_id',
    `${CaseGroup}`,
    `${CaseGroupApi}?organisation_id=${userOrganisationId}&service_type_id=1`,
    '', 6
  );

  const caseTypeDropdownField = createDropdownField(axiosPrivate,
    'case_type_id',
    'case_type_id',
    `${CaseTypeName}`,
    ``,
    '', 6
  );

  const customerDropdownField = {
    name: "contact_id",
    id: "contact_number, company_name, last_name, first_name",
    api: `${CustomerApi}`,
    label: `${Contact}`,
    type: "input-select",
    value: "",
    colSize: 6,
    required: true,
    onSelectedChange : async function (selectedId, updatedFields) { 
      const linkField = updatedFields.find((field) => field.id === 'link_id');
      
      if (linkField) {
        const endPoint = `${CustomerLinkApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
        await linkField.fetchOptions(selectedId, false, endPoint);
        setFormFields([...updatedFields]);
      } 
    }
  };

  const linkDropdownField = createDropdownField(axiosPrivate,
    'link_id',
    'link_id',
    `${Link}`,
    ``,
    '', 6, true, 
    //'contact.branch.contact_number, contact.branch.name, contact.branch.street_number, contact.branch.street_name'
    //'contact.branch.contact_number, contact.branch.name'
    //'contact_branch.contact_number, contact_branch.name, product.name | contact.contact_number, contact.company_name, product.name'
    //'contact_branch.contact_number, contact_branch.name | contact.contact_number, contact.last_name | contact.contact_number, contact.first_name, contact.middle_name, [product.name]'
    "contact_branch.contact_number, contact_branch.name | contact.contact_number, contact.company_name | contact.contact_number, contact.last_name, contact.first_name | [product.name]"
  );

  /* const Prioritydropdown = createDropdownField(axiosPrivate,
    'priority_id',
    'priority_id',
    `${Priority}`,
    `${PriorityApi}?organisation_id=${userOrganisationId}`,
    '', 6
  ); */

  const ResolutionStatusdropdown = createDropdownField(axiosPrivate,
    'resolution_status_id',
    'resolution_status_id',
    `${ResolutionStatus}`,
    `${ResolutionStatusApi}?organisation_id=${userOrganisationId}`,
    '', 6
  );

  useLayoutEffect(() => {

    const fetchData = async () => {
      try {
        if (!isNewFieldAdded) {
          const updatedFields = [
            caseGroupDropdownField, 
            caseTypeDropdownField, 
            //customerDropdownField, 
            linkDropdownField, 
            //Prioritydropdown, 
            //ResolutionStatusdropdown, 
            ...formFields];
          //const indexOfName = updatedFields.findIndex((formField) => formField.id === 'case_Category_id');

          await updatedFields[0].fetchOptions();
          //await customerDropdownField.fetchOptions();
          //await Prioritydropdown.fetchOptions();
          await ResolutionStatusdropdown.fetchOptions();

          const linkField = updatedFields.find((field) => field.id === 'link_id');
          
          const selectedId = currentUser.contact.id  
          if (linkField) {
            const endPoint = `${CustomerLinkApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
            await linkField.fetchOptions(selectedId, false, endPoint);
          } 

          
          setFormFields(updatedFields);
          setIsNewFieldAdded(true);

          /* const customerField = updatedFields.find((field) => field.name === 'contact_id');
          customerField.onSelectedChange = async (selectedId, updatedFields) => { 
            const linkField = updatedFields.find((field) => field.id === 'link_id');
            
            if (linkField) {
              const endPoint = `${CustomerLinkApi}?organisation_id=${userOrganisationId}&contact_id=${selectedId}`
              await linkField.fetchOptions(selectedId, false, endPoint);
              setFormFields([...updatedFields]);
            } 
          }; */
        }
      } catch (error) {
        //console.error('Error fetching options:', error);
      }
      
    };

    fetchData();

  }, [formFields, isNewFieldAdded, caseGroupDropdownField, caseTypeDropdownField, customerDropdownField]);

  caseGroupDropdownField.onChange = async (selectedCaseGroupId, updatedFields) => { 
    const caseTypeField = updatedFields.find((field) => field.id === 'case_type_id');
    
    if (caseTypeField) {
      const endPoint = `${CaseTypeApi}?organisation_id=${userOrganisationId}&case_group_id=${selectedCaseGroupId}`
      
      await caseTypeField.fetchOptions(selectedCaseGroupId, false, endPoint, true);
      setCaseTypeData(caseTypeField.data)
      setSelectedCaseTypeId(null);
      setFormFields([...updatedFields]);
    } 
  };

  /* useEffect(() => {
    if (selectedCaseTypeId !== null) {
      const rec = caseTypeData[selectedCaseTypeId] || {}; 
      handleCaseTypeChange(updatedFields, rec); 
    } 
  }, [selectedCaseTypeId, caseTypeData]);  */

  /* caseTypeDropdownField.onChange = async (selectedCaseTypeId, updatedFields) => {
    setSelectedCaseTypeId(selectedCaseTypeId);
    setUpdatedFields(updatedFields)
  } */

  /* const handleCaseTypeChange = (updatedFields, rec) => {
    const indexOfSubject = updatedFields.findIndex((formField) => formField.id === 'subject');
    const existingPriorityIndex = updatedFields.findIndex(formField => formField.id === "priority");
    const existingSlaDetailIndex = updatedFields.findIndex((formField) => formField.id === 'sla_details');

    if(selectedCaseTypeId <=0 && existingPriorityIndex > -1) { 
      updatedFields = updatedFields.filter(field => field.id !== "priority");
      updatedFields = updatedFields.filter(field => field.id !== "sla_details");
  
      setFormFields([...updatedFields]);
      return
    }

    const priority_field = {
      id: 'priority',
      name: 'priority',
      label: `${Priority}`,
      type: 'html',
      html: (
        <>
          <span style={{ color: rec.priority.color }}>
            <i className="fa fa-flag"></i> {rec.priority.name}
          </span>
        </>
      ),
      required: false,
      colSize: 6,
    };
    
    const popOverBody = <>
        <h6>{ResolutionTeam}</h6>
        <Table style={{ fontSize: '11px' }}>
            <tbody>
              <tr className=''>
                  <th scope='row'>{PickUpTime}</th>
                  <td>{formatToDuration(rec.resolution_pickup_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{ResolutionTime}</th>
                  <td>{formatToDuration(rec.resolution_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{DelegationTime}</th>
                  <td>{formatToDuration(rec.resolution_delegation_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationFunctionalTime}</th>
                  <td>{formatToDuration(rec.resolution_escalation_time1)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationExecutiveTime}</th>
                  <td>{formatToDuration(rec.resolution_escalation_time2)}</td>
              </tr>
            </tbody>
        </Table>

        <br/>
        <h6>{DelegateTeam}</h6>
        <Table style={{ fontSize: '11px' }}>
            <tbody>
              <tr className=''>
                  <th scope='row'>{PickUpTime}</th>
                  <td>{formatToDuration(rec.delegation_pickup_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{ResolutionTime}</th>
                  <td>{formatToDuration(rec.delegation_resolution_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{DelegationTime}</th>
                  <td>{formatToDuration(rec.delegation_delegation_time)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationFunctionalTime}</th>
                  <td>{formatToDuration(rec.delegation_escalation_time1)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationExecutiveTime}</th>
                  <td>{formatToDuration(rec.delegation_escalation_time2)}</td>
              </tr>
            </tbody>
        </Table>

        <br/>
        <h6>{ExternalDelegateTeam}</h6>
        <Table style={{ fontSize: '11px' }}>
            <tbody>
              <tr className=''>
                  <th scope='row'>{PickUpTime}</th>
                  <td>{formatToDuration(rec.external_delegation_pickup_time || 0)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{ResolutionTime}</th>
                  <td>{formatToDuration(rec.external_delegation_resolution_time || 0)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationFunctionalTime}</th>
                  <td>{formatToDuration(rec.external_delegation_escalation_time1 || 0)}</td>
              </tr>
              <tr className=''>
                  <th scope='row'>{EscalationExecutiveTime}</th>
                  <td>{formatToDuration(rec.external_delegation_escalation_time2 || 0)}</td>
              </tr>
            </tbody>
        </Table>
      </>

    const popover = {
      id: 3,
      placement: "left",
      Popoverheader: `${GlobalResolutionTime}: ${formatToDuration(rec.global_resolution_time)}`,
      Popoverbody: popOverBody,
      popoverBodyClass: "scrollable-popover",
      //popoverBodyStyle: { maxHeight: '250px', overflowY: 'auto' },
      //popoverStyle: { maxWidth: '500px' },
      btncolor: "primary",
      btntext: "View Timeline",
      trigger: "hover",
    };
    
    const sla_field = {
      id: 'sla_details',
      name: 'sla_details',
      label: `${Timeline}`,
      type: 'html',
      html: (
        <>
          <CommonPopover key={popover.id} item={popover} />
        </>
      ),
      required: false,
      colSize: 6,
    };

    if (existingPriorityIndex > -1) { 
        updatedFields[existingPriorityIndex] = priority_field;
        updatedFields[existingSlaDetailIndex] = sla_field;
    } else {
        updatedFields.splice(indexOfSubject + 1, 0, ...[priority_field, sla_field]);
    }

    setFormFields([...updatedFields]);
  } */

  const addNewRecord =  async (newRecord) => {
      if (newRecord === '') { 
        errors.showMessages();
      }
      /* console.log(newRecord)
      return */
      const newRecordTemp = {
        case_type_id: newRecord.case_type_id,
        contact_id: currentUser.contact.id,
        link_id: newRecord.link_id,
        //priority_id: newRecord.priority_id,
        //resolution_status_id: newRecord.resolution_status_id,
        subject: newRecord.subject,
        message: newRecord.message,
        due_date: newRecord.due_date,
       };

      try {
          await axiosPrivate.post(`${CaseApi}/customer`, newRecordTemp).then((resp) => {
            toast.success(`${resp.data.track_number} is successfully added.`)
            history(lists);
          });
      } catch (error) {
        if (error.response && error.response.status === 422) {
          toast.error('Validation Errors');
        } else if (error.response && error.response.status === 400) {
          toast.error(error.response.data.detail);
        } else {
          toast.error('Form submission error');
        }
        throw error;
    }   
  };


  return (
    <Fragment>
      <Breadcrumbs parent="SelfCare" title="New Ticket" mainTitle="New Ticket" />
      <Container fluid={true}>
        <Row>
          <Col sm='12'>
            <CardRibbonWithForm 
              formFields={formFields} 
              onSubmit={addNewRecord} 
              ribbonUrl={lists} 
            />
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default MyCaseCreate;